import React, { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";

export const CookieBanner = () => {
    const [show, setShow] = useState(false);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem("bf_cookie_consent");
        if (!consent) {
            const showTimeout = setTimeout(() => {
                setShow(true);
                const visibleTimeout = setTimeout(() => setVisible(true), 50);
                return () => clearTimeout(visibleTimeout);
            }, 800);
            return () => clearTimeout(showTimeout);
        }
    }, []);

    useEffect(() => {
        const handleOpen = () => {
            setShow(true);
            setTimeout(() => setVisible(true), 50);
        };
        window.addEventListener("open-cookie-banner", handleOpen);
        return () => window.removeEventListener("open-cookie-banner", handleOpen);
    }, []);

    const dismiss = (consentValue) => {
        localStorage.setItem("bf_cookie_consent", consentValue);
        
        // Connecter le choix de l'utilisateur à PostHog pour respecter le consentement
        if (window.posthog) {
            if (consentValue === "accepted") {
                window.posthog.opt_in_capturing();
            } else {
                window.posthog.opt_out_capturing();
            }
        }

        setVisible(false);
        setTimeout(() => {
            setShow(false);
        }, 500);
    };

    if (!show) return null;

    return (
        <div
            className={`fixed bottom-16 sm:bottom-14 left-3 right-3 sm:left-6 sm:right-6 lg:left-auto lg:right-6 lg:max-w-md z-50 card-elev p-5 shadow-2xl transition-all duration-500 ease-in-out ${
                visible
                    ? "opacity-100 translate-y-0 scale-100"
                    : "opacity-0 translate-y-10 scale-95 pointer-events-none"
            }`}
            data-testid="cookie-banner"
        >
            <div className="flex items-start gap-3">
                <Cookie className="text-[#FFB300] flex-shrink-0" size={22} />
                <div className="flex-1">
                    <h4 className="font-heading font-bold text-white text-sm mb-1">
                        Cookies & Vie privée
                    </h4>
                    <p className="text-xs text-gray-400 leading-relaxed mb-3">
                        Nous utilisons des cookies pour améliorer votre
                        expérience et analyser le trafic, conformément au
                        RGPD. Vous pouvez accepter ou refuser à tout moment.
                    </p>
                    <div className="flex flex-wrap gap-2">
                        <button
                            onClick={() => dismiss("accepted")}
                            className="btn-green !py-2 !px-4 text-xs"
                            data-testid="cookie-accept"
                        >
                            Tout accepter
                        </button>
                        <button
                            onClick={() => dismiss("declined")}
                            className="btn-outline !py-2 !px-4 text-xs"
                            data-testid="cookie-decline"
                        >
                            Refuser
                        </button>
                    </div>
                </div>
                <button
                    onClick={() => dismiss("declined")}
                    className="text-gray-400 hover:text-slate-900 dark:hover:text-white"
                    aria-label="Fermer"
                    data-testid="cookie-close"
                >
                    <X size={18} />
                </button>
            </div>
        </div>
    );
};

export default CookieBanner;
